import React from "react"
import { FormSectionElements, FormSections, ProgramContainer } from "../../entities/formTemplateDataType";
import { getParentSection, getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    bodyMsg: string;
    title: string;
    isEng: boolean;
    field?: FormSectionElements;
    callbackStepIndex?: (index: number, currentIndex?: number) => void;
}

export class InformationalRichTextComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    private richTextRef = React.createRef<HTMLDivElement>();
    constructor(props: Props) {
        super(props);

    }

    componentDidMount(): void {
        this.addGoToStepAction();
    }

    componentDidUpdate(): void {
        this.cleanupGotoStepListeners();
        this.addGoToStepAction();
    }

    componentWillUnmount(): void {
        this.cleanupGotoStepListeners();
    }

    private static goToStepClickHandlers = new WeakMap<Element, EventListener>();

    cleanupGotoStepListeners = () => {
        const container = this.richTextRef.current;
        if (!container) return;

        const buttons = container.getElementsByClassName("gotoStep");
        for (let i = 0; i < buttons.length; i++) {
            const button = buttons.item(i);
            if (!button) continue;

            const clickHandler = InformationalRichTextComponent.goToStepClickHandlers.get(button);
            if (clickHandler) {
                button.removeEventListener("click", clickHandler);
                InformationalRichTextComponent.goToStepClickHandlers.delete(button);
            }
        }
    };

    addGoToStepAction = () => {
        const container = this.richTextRef.current;
        if (!container || !this.props.callbackStepIndex) return;

        const buttons = container.getElementsByClassName("gotoStep");
        let currentIndex: number | undefined;

        if (this.props.field) {
            const section = getParentSection(this.props.field) as FormSections;
            const programContainer = getRootComponent(this.props.field) as ProgramContainer;
            currentIndex = programContainer?.ListOfFormSections?.findIndex(
                (p) => p.Id === section?.Id
            );
            if (currentIndex != null && currentIndex < 0) {
                currentIndex = undefined;
            }
        }

        for (let i = 0; i < buttons.length; i++) {
            const button = buttons.item(i);
            if (!button) continue;

            if (InformationalRichTextComponent.goToStepClickHandlers.has(button)) {
                continue;
            }

            const clickHandler = (e: Event) => {
                e.preventDefault();
                const indexAttr = button.getAttribute("data-index");
                if (!indexAttr) return;
                const nextIndex = Number.parseInt(indexAttr, 10);
                if (!Number.isFinite(nextIndex)) return;
                this.props.callbackStepIndex?.(nextIndex, currentIndex);
            };

            button.addEventListener("click", clickHandler);
            InformationalRichTextComponent.goToStepClickHandlers.set(button, clickHandler);
        }
    };

    generateHtmlString = () => {
        let html = [];
        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser(); 
        let bodyMsg=this.props.bodyMsg;
        if(/<[a-z][\s\S]*>/i.test(this.props.bodyMsg)){
             bodyMsg=htmlToReactParser.parse(this.props.bodyMsg);
        }
   
        let title = this.props.title;

        html.push(
            <div ref={this.richTextRef}>
                {bodyMsg}
            </div>
        );
        return html;
    }


    render() {
        return (
            this.generateHtmlString()
        )
    }
}
